/*
 * @Description: 初始化获取设备信息 Web sdk  http://npm.al.com/package/@al/device-data-sdk
 * @FilePath: /eu-mobile-m/common/utils/aLDeviceSDK.ts
 */

import { CtxType } from "@al/next/al-ex";

import Analytics from "../tracker/analytics";

// TODO: 待sdk兼容服务端时，改用import方式
// eslint-disable-next-line
const DeviceSDK = process.server ? null : require("@al/device-data-sdk").default;

export default DeviceSDK;

export async function initDeviceSDK(ctx: CtxType): Promise<void> {
  if (!DeviceSDK) {
    throw new Error("server 端不能使用 ALDeviceSDK");
  }
  // 初始化
  await DeviceSDK.init({
    url:
      process.env.BUILD_ENV === "prod"
        ? "https://r.silvrr.com/web/device/fingerprint"
        : "https://test-r.silvrr.com/web/device/fingerprint",
    extra: {
      //可配置的上报业务字段如下，请注意数据格式
      app_brand: "wca",
      country_id: ctx.locale.countryId,
      user_id: ctx.store.getState().sign?.userDetail?.uid,
      adjust_id: await (Analytics.getAdjustId() || ""),
      ext: {},
    },
    //uuid配置，如不配置uuid则为空
    uuidConfig: {
      apiHost: process.env.BUILD_ENV === "prod" ? "r.silvrr.com" : "test-r.silvrr.com",
      env: "wca", //wca(欧洲M站)/sp(欧洲openpay)/ op(aku openpay)
      protocol: "https://", //默认https://，如不更改则不设置这个字段
    },
    reportThirdHost: false, //是否为第三方openpay上报数据，默认false，可选
    reportDevelopEnv: true, //是否上报到测试环境，默认为false，可选
    reportAfterInited: false, //是否在init之后上报数据，默认为true，可选
    reportIsEncrypt: true, //是否加密上报设备数据
  });
}
